import BaseComments from '../AllComments/BaseComments';

const AdComments = () => {
  return <BaseComments title="" />;
};

export default AdComments;
